
import {defineComponent} from "vue";
import BannerOverview from '@/components/layouts/banners/BannerOverview.vue';

export default defineComponent({
  name: "CustomerBannerOverview",
  components: {BannerOverview},
});
